/** feature detail info */
export const FITTINGDTL = 'detail';
export const FITTINGVER = 'version';
export const FITTINGSIZE = 'label';
export const FITTING_EC = 'hasEC';
export const LENGTH_DG = 'use_diagonal';
export const FITTING_INSULATION = 'withInsulation';
/** feature flag to show side takeoff circles on DUCT_LENGTH - @2026/05/28 */
export const FITTING_STO = 'add_take_off';
export const ZOOM_LV = 'zoomLevel';
/**
 * text object in style
 * @deprecated no longer in use
 */
export const FITTINGTEXT = 'textObject';
/**
 * key attached to feature of symbol type, to help to decide the style for feature
 * `SymbolType`, to decide the symbol shape to draw
 */
export const FITTINGTYPE = 'type';
/**
 * basic length info from modal
 */
export const FITTINGKEY = 'currentFitting';
/**
 * cache for reveal the length of length in real time
 */
export const CURRENT_FEATURE = 'CURRENT_FEATURE';

export const DEFAULT_LINE_COLOR = '#CCCCCC';
export const DEFAULT_PURPLE_COLOR = 'darkviolet';
export const DEFAULT_DOT_RADIUS = 12;
export const DEFAULT_NOTE_TXT = 'select me to edit...';
export const DEFAULT_EC_TXT = 'E.C.';
export const DEFAULT_DIGN_TXT = 'D.G.';
/** a small offset for diagonal height for duct length */
export const HEIGHT_ENHANCE_IN_DIAGONAL = 1.1;
/**
 * zoom level related offset ratio
 */
export const scaleRatio = 1.5;

/**
 * default(initial diamon radius)
 */
export const DEFAULT_DIAMOND_RADIUS = 2;
/**
 * default(initial) equiement font size
 */
export const DEFAULT_EQUIPMENT_FONT_SIZE = 8;
/** for symbol mouse over highlight size font limitation - @2025/11/05  */
export const MAX_FONT_SIZE = 18;
/**
 * initial triangle symbol radius 6, @2024/03/28
 */
export const DEFAULT_TRIANGLE_RADIUS = 4;
export const DUCK_VERSION_NUMBER = '-1';
export const LineResizingsMinLength = 20;
export const MINIMALAMPLIFYZOOMLEVEL = 5;
export const LINETHICKNESSFACTOR = 0.5;

/**
 * Front-end assigned marked-up box size: [w, h]
 * @2025/08/12
 */
export const MARKUP_EQUIPMENT_SIZE = [40, 20];

export const zoomingFeatureMaxLengthOfMap = 1 / 3;

/**
 * limit the batch selection amount to prevent the browser crash
 * @date 2024/12/11
 */
export const BATCHSELECTIONMAXFEATRUES = 1000;

/**
 * common stroke width for all symbols
 */
export const COMMON_STROKE_WIDTH = 2;

/**
 * box stroke applying after this zoom level, initially use `1`
 * @log change value from 2 to 2.4 - 2025/03/18
 */
export const MINIMAL_LEVEL_THICKNESS_CHANGE = 2.4;

/**
 * whole map restying pending time in milisecond, NO less than `120`!
 *
 * @log change from `600` to `300` as Simon requested at 2024/04/15
 */
export const FULL_RERENDERING_DELAY = 300;

/**
 * drawing auto moving boundary ratio by whole width
 * @2025/04/30
 */
export const EdgeThresholdRatio = 0.05;

/** max zoom level for map animation target - 2025/03/25 */
export const FLY_TO_DEFAULT_ZOOM = 3;

/**
 * note size augument ratio by zoomingfy level change
 */
export const NOTE_TEXT_SIZING_RATIO = 1.2;

/**
 * global `hitTolerance`
 * @date 2025/12/02
 *
 * make to 8 to select pipe line easily and cut
 * @date 2026/03/26
 */
export const GLB_HIT_TOLERANCE = 8;
